<template>
  <div class="anchor_mian">
    <div class="anchor_mian_mb" @click="clickMb">

    </div>
    <div class="anchor_con">
      <div class="anchor_tab">
        <div class="anchor_tabli" :class="tabindex == -1 ? 'anchor_tabact' : ''" @click="tabindex=-1">主播模板</div>
        <div class="anchor_tabli" :class="tabindex == index ? 'anchor_tabact' : ''" v-for="(item, index) in anchor_list" :key="index" @click="tabindex = index">
          {{ item.catname }}
        </div>
      </div>
      <div class="anchor_listcon" v-if="tabindex == -1" @scroll="scrollList($event)">
        <div v-if="template_list.length === 0" style="text-align:center;fontSize:24px;color:#999;">没有配音模板</div>
        <div class="anchor_li" v-for="(item2, index2) in template_list" :key="index2">
          <div class="flex_ali">
            <img :src="item2.headpath" class="anchor_img" />
            <div>
              <p class="anchor_name">{{ item2.speakername }}</p>
              <p class="anchor_desp" style="width:190px;">
                <span>语速：{{item2.speed}}</span>
                <span>语调：{{item2.intonation}}</span>
                <span>音量：{{item2.volume}}</span>
              </p>
            </div>
          </div>
          <div class="flex_ali">
            <div class="anchor_btn anchor_btn1 anchor_btn_tm" @click="removeTemplate(item2.id)">
              <span>删除</span>
            </div>
            <div class="anchor_btn anchor_btn1 anchor_btn_tm" @click="selectTemplate(item2)">
              <span>使用</span>
            </div>
          </div>
        </div>
      </div>
      <div class="anchor_listcon" v-for="(item, index) in anchor_list" :key="index" v-if="tabindex == index">
        <div class="anchor_li" v-for="(item2, index2) in item.zhuboList" :key="index2" :class="item2.zbid == anchor.zbid?'choseAnchor':''">
          <div class="flex_ali" style="width:230px;">
            <div class="anchor_img_con">
              <!-- <span class="">限免</span> -->
              <img :src="item2.zbcover" class="anchor_img" />
              <div class="anchor_svip" :class="item2.feature==='1' || (item2.feature==='2' && item2.issvipzb==='1')?'':'anchor_pt'">{{item2.feature==='1' ? (from==='210767'||from==='110767'?'王牌主播':'金牌主播') : '普通主播'}}</div>              
              <!-- <img src="../assets/images/img2/anchor_svip.png" class="anchor_svip" v-if="item2.feature==='1'"> -->
            </div>
            <div>
              <p class="anchor_name">{{ item2.speakername }}</p>
              <p class="anchor_desp" style="width:190px;">{{ item2.zbdesp }}</p>
            </div>
          </div>
          <div class="flex_ali">
            <div class="anchor_btn" @click="anchor_audio.play(item2.zbmusicurl)" v-if="anchor_audio.audiourl !== item2.zbmusicurl">
              <img src="../assets/images/play.png" />
              <span>试听</span>
            </div>
            <div class="anchor_btn anchor_btn2" @click="anchor_audio.play(item2.zbmusicurl)" v-else>
              <img src="../assets/images/pause.png" />
              <span>暂停</span>
            </div>
            <div class="anchor_btn anchor_btn1" @click="useAnchor(item2)">
              <img src="../assets/images/enit.png" />
              <span>使用</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script scoped>
import PlayListAudio from "../utils/PlayListAudio.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      tabindex: 1, //tab选择索引
      anchor_audio: new PlayListAudio(),
      page_template: 1,//主播模板分页
      lastPage: false,//主播模板是否是最后一页
      template_list: [],//主播模板列表
      from: '110710',
    };
  },
  computed: {
    ...mapState(["show_anchor", "anchor_list", "anchor"]),
  },
  mounted() {
    console.log(111111,localStorage.getItem("qd"))    
    this.time = setInterval (()=>{
      if(localStorage.getItem("qd")) {
        console.log(33333,localStorage.getItem("qd"))
        this.from = localStorage.getItem("qd")
        this.getAnchorList();      
        this.getAnchorTemplate(false)
        clearInterval(this.time)
      }
    },100)   
    
  },
  props:{
    show:{
      type:Boolean
    }
  },
  methods: {
    // 选择配音模板
    selectTemplate(item){
      this.$emit('selectTemplate',item)
    },
    // 删除配音模板
    removeTemplate(id) {
      console.log(id)
      this.$confirm('确定删除该配音模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let json = {
          id: id,
          delect_state: '1',
        }
        let url =
          this.$store.state.app_api + this.$store.state.app_url.updatazbtemplate;
        this.$request.postHttp(json, url, (res) => {
          if (res.rc === '0') {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getAnchorTemplate(false)
            return
          }
          this.$message({
            message: '删除失败!'
          });
        })


      }).catch(() => {

      });
    },
    // 获取配音模板
    getAnchorTemplate(isextend) {
      if (isextend) {
        this.page_template += 1
      }else{
        this.page_template = 1
        this.lastPage = false
      }
      if (this.lastPage) return
      let json = {
        page: this.page_template,
        rows: 20,
      }
      let url =
        this.$store.state.app_api + this.$store.state.app_url.getzbtemplate;
      this.$request.postHttp(json, url, (res) => {
        this.lastPage = res.model.lastPage
        if (isextend) {
          this.template_list.concat(res.model.list)
        } else {
          this.template_list = res.model.list
        }
      })
    },
    // 滑动触底事件
    scrollList(e) {
      const dom = e.target;
      var scrollTop = dom.scrollTop; //滑入屏幕上方的高度
      var windowHeitht = dom.clientHeight; //能看到的页面的高度
      var scrollHeight = dom.scrollHeight; //监控的整个div的高度（包括现在看到的和上下隐藏起来看不到的）
      let total = scrollTop + windowHeitht;
      if (total == scrollHeight) {
        this.getAnchorTemplate(true);
      }
    },
    // 获取主播列表
    getAnchorList() {
      let self = this;
      if (self.$store.state.anchor_list.length !== 0) return
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qryttszhubov5;
        console.log(88888,url)
      this.$request.postHttp({}, url, (decData) => {
        console.log(77777,decData)
        if (!self.$store.state.anchor.zbid) self.$store.commit("setAnchor", decData.model.defaultTtszhuboList[0]);
        self.$store.commit("setAnchorList", decData.model.ttsZhuboAllList);
      });
    },
    // 抛出背景蒙版点击事件
    clickMb() {
      this.$emit("mb");
    },
    // 抛出组件使用主播事件
    useAnchor(item) {
      this.$store.commit("setAnchor", item);
      this.$emit("user", item);
    },    
  },
  watch: {
    
    // 监听主播选择界面显示状态
    show_anchor: function (val) {
      // 界面隐藏时停止主播试听播放器
      if (!val) this.anchor_audio.stop()
    },
    show: function (val) {
      if(val)this.getAnchorTemplate(false)
    }
  }
};
</script>
<style>
.anchor_img_con{
  position: relative;
  width: 60px;
  height: 60px;
  margin-right: 16px;
}
.anchor_svip{
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 20px;  
  text-align: center;
  background: #6766E1;
  color: #fff;
  border-radius: 16px;
  font-size: 10px;  
}
.anchor_pt {
  background: #DDBB83;
}
.anchor_btn2 {
  background-color: rgba(254, 186, 7, 0.15) !important;
}
.anchor_btn2 span {
  color: #74b9ff;
}
.anchor_btn1 {
  background-color: #74b9ff !important;
  margin-left: 16px;
}
.anchor_btn span {
  font-size: 12px;
}
.anchor_btn img {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}
.anchor_btn {
  cursor: pointer;
  width: 78px;
  height: 36px;
  background-color: #eee;
  border-radius: 6px;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.anchor_desp {
  color: #999;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.anchor_name {
  font-size: 16px;
}
.anchor_img {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  background-color: #eee;
  margin-right: 16px;
}
.anchor_li {
  width: 440px;
  height: 80px;
  background: #f8f8f8;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 24px;
  float: left;
  margin-bottom: 16px;
  padding: 10px 16px;
}
.anchor_li:nth-child(2n + 1) {
  margin-left: 0;
}
.anchor_listcon {
  width: 970px;
  height: 555px;
  background: #ffffff;
  border-radius: 10px;
  margin-left: 24px;
  padding: 24px;
  overflow-y: scroll;
}
.anchor_listcon::-webkit-scrollbar {
  width: 10px; /*滚动条宽度*/
  height: 10px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
.anchor_listcon::-webkit-scrollbar-track {
  border-radius: 5px; /*滚动条的背景区域的圆角*/
}
/*定义滑块 内阴影+圆角*/
.anchor_listcon::-webkit-scrollbar-thumb {
  border-radius: 5px; /*滚动条的圆角*/
  background-color: rgba(153, 153, 153, 0.4);
}
.anchor_tabact {
  background-color: #74b9ff;
}
.anchor_tabli {
  width: 100%;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
}
.anchor_tab {
  width: 220px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
  height: 555px;
  overflow-y: scroll;
}
.anchor_tab::-webkit-scrollbar {
  width: 10px; /*滚动条宽度*/
  height: 10px; /*滚动条高度*/
}
/*定义滚动条轨道 内阴影+圆角*/
.anchor_tab::-webkit-scrollbar-track {
  border-radius: 5px; /*滚动条的背景区域的圆角*/
}
/*定义滑块 内阴影+圆角*/
.anchor_tab::-webkit-scrollbar-thumb {
  border-radius: 5px; /*滚动条的圆角*/
  background-color: rgba(153, 153, 153, 0.4);
}
.anchor_mian {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index:1005;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.anchor_con {
  display: flex;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}
.anchor_mian_mb {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
}
.choseAnchor {
  border: 2px solid #74b9ff;
}
</style>



// WEBPACK FOOTER //
// src/components/anchor.vue